module.exports = "/_next/static/images/phonecall-efd571b034ae11add1aac7f372df6544.svg";